import { FunctionComponent, lazy } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";

import { AuthGuard } from "@dw/components";
import { LazyLoader } from "@dw/components/core";
import { ROUTES } from "@dw/constants";
import { getRouteName } from "@dw/utils";

import { AuthContextProvider } from "./contexts";
import { ErrorBoundary } from "./ErrorBoundary";

const LoginPage = LazyLoader(lazy(() => import("./pages/LoginPage")));

const DashboardPage = LazyLoader(lazy(() => import("./pages/DashboardPage")));
const ManageDanceSchoolPage = LazyLoader(lazy(() => import("./pages/ManageDanceSchoolPage")));
const ManageLocationPage = LazyLoader(lazy(() => import("./pages/ManageLocationPage")));

const ManageMyProfilePage = LazyLoader(lazy(() => import("./pages/ManageMyProfilePage")));

const ManageStudentPage = LazyLoader(lazy(() => import("./pages/ManageStudentPage")));
const ViewDancerAccountPage = LazyLoader(lazy(() => import("./pages/ViewDancerAccountPage")));

const ViewCommunicationDetailsPage = LazyLoader(lazy(() => import('./pages/ViewCommunicationDetailsPage')));

const RegisterTrialClassPage = LazyLoader(lazy(() => import('./pages/RegisterTrialClassPage')));
const BulkInvoicesPage = LazyLoader(lazy(() => import('./pages/BulkInvoicesPage')));

export const AppRouter: FunctionComponent = () => {
  const routes = createBrowserRouter([
    {
      element: (
        <AuthContextProvider>
          <ErrorBoundary>
            <LoginPage />
          </ErrorBoundary>
        </AuthContextProvider>
      ),
      index: true,
    },
    {
      path: getRouteName(ROUTES.Dashboard),
      element: (
        <AuthContextProvider>
          <ErrorBoundary>
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          </ErrorBoundary>
        </AuthContextProvider>
      ),
      children: [
        {
          path: getRouteName(ROUTES.ManageDanceSchool, ROUTES.Dashboard),
          element: <ManageDanceSchoolPage />,
        },
        {
          path: getRouteName(ROUTES.ManageLocation, ROUTES.Dashboard),
          element: <ManageLocationPage />,
        },
        {
          path: getRouteName(ROUTES.ManageMyProfile, ROUTES.Dashboard),
          element: <ManageMyProfilePage />,
        },
        {
          path: getRouteName(ROUTES.CreateStudent, ROUTES.Dashboard),
          element: <ManageStudentPage />,
        },
        {
          path: getRouteName(ROUTES.ManageStudent, ROUTES.Dashboard),
          element: <ManageStudentPage />,
        },
        {
          path: getRouteName(ROUTES.ViewDancerAccount, ROUTES.Dashboard),
          element: <ViewDancerAccountPage />,
        },
        {
          path: getRouteName(ROUTES.ViewCommunicationDetails, ROUTES.Dashboard),
          element: <ViewCommunicationDetailsPage />,
        },
        {
          path: getRouteName(ROUTES.RegisterTrialClass, ROUTES.Dashboard),
          element: <RegisterTrialClassPage />
        },
        {
          path: getRouteName(ROUTES.BulkInvoices, ROUTES.Dashboard),
          element: <BulkInvoicesPage />
        }
      ],
    },
    {
      path: "*",
      element: <Navigate to={ROUTES.Root} replace />,
    },
  ]);

  return <RouterProvider router={routes} />;
};
